import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  input,
  Output,
} from '@angular/core';

@Component({
  selector: 'acl-device-add-to-installation',
  standalone: false,
  templateUrl: './device-add-to-installation.component.html',
  styleUrl: './device-add-to-installation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceAddToInstallationComponent {
  // disable the form
  readonly disableForm = input<boolean>(false);
  readonly ctdLimitReached = input<boolean>(false);

  @Output() readonly openModal = new EventEmitter();

  openAddDeviceModal(): void {
    this.openModal.emit();
  }
}
